export const NAVIGATION_ID = "NAVIGATION_ID";
